import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['form', 'link']

  download(event) {
    event.preventDefault()

    const formData = new FormData(this.formTarget)
    const params = new URLSearchParams(formData)

    formData.entries().forEach(([key, value]) => {
      if (value !== '') params.append(key, value)
    })

    const url = new URL(this.linkTarget.href, window.location.origin)
    url.search = params

    window.location.href = url.toString()
  }
}
